import React, { useEffect, useState } from "react";
import { Container, Row, Col, Navbar, Nav, Badge } from "react-bootstrap";
import { Card, CardBody, CardFooter } from "shards-react";
import "bootstrap/dist/css/bootstrap.min.css";
import "shards-ui/dist/css/shards.min.css";
import { primaryColor } from "../config/colors";
import FoodInstructionDialog from "./FoodInstructionDialog";
import {
  formateNumber,
  getFormattedDateTime,
  getKOTStatusIcon,
  getTotalPriceOfFoodItem,
  navigatePage,
} from "../config";
import { strings } from "../localization";
import OrderStatusContainer from "./OrderStatusContainer";
import "./OrderItemCard.css";

function OrderItemsCard({ order, onCardClick }) {
  const [showNoteDialog, setShowNoteDialog] = useState(false);
  const [note, setNote] = useState("");
  const [foodName, seFoodName] = useState("");

  const getTotalQty = () => {
    const totalQuantity = order.dataArray.reduce(
      (sum, item) => sum + Number(item.quantity),
      0
    );
    return totalQuantity;
  };

  return (
    <>
      <div
        className="w-100 px-1 py-1"
        key={order.id}
        style={{ cursor: "pointer" }}
        onClick={(e) => onCardClick(order)}
      >
        <Card
          className="mb-2 shadow-sm rounded w-100"
          style={{ borderRadius: "10px" }}
        >
          <CardBody className="px-2 py-2 orderItemCardBody">
            {/* Row 1: Order ID and Status */}
            <Row className="align-items-center mb-2">
              <Col xs="6" className="truncate-multiline">
                <strong>{order.orderID}</strong>
              </Col>
              {/* TODO : Once ready for backend uncomment this code  */}
              <Col xs="6" className="d-flex justify-content-end">
                <OrderStatusContainer status={order.status} />
              </Col>
            </Row>

            {/* Row 2: Date and Time */}
            <Row className="align-items-center mb-3">
              <Col xs="6" className="d-flex justify-content-between">
                <small className="text-muted fw-bold">
                  {order.orderDate || ""}
                </small>
              </Col>
              <Col xs="6" className="d-flex justify-content-end">
                <small className="text-muted">{order.orderTime || ""}</small>
              </Col>
            </Row>

            <hr className="my-2" />

            {/* Column Headers for Items */}
            <Row className="font-weight-bold text-muted small mb-2">
              <Col xs="6" md="6">
                {strings.item}
              </Col>
              <Col xs="3" md="3" className="text-center">
                {strings.qty}
              </Col>
              <Col xs="3" md="3" className="text-end">
                {strings.price}
              </Col>
            </Row>

            {/* Food Items Section */}
            {order && order.dataArray && order.dataArray.length > 0
              ? order.dataArray.slice(0, 3).map((item, idx) => (
                  <Row key={idx} className="align-items-start mb-3">
                    <Col xs="6">
                      <Row>
                        <Col xs="10">
                          <div className="d-flex align-items-start" style={{marginBottom: '1rem'}}>
                            <p
                              className="truncate-multiline"
                              style={{
                                overflow: "hidden",
                                lineHeight: "1.4em",
                                color: "#5a6169",
                                marginRight: 3,
                                marginBottom: 0,
                              }}
                            >
                              {item.name}
                            </p>
                            {getKOTStatusIcon(item.kotStatus, 18, "black")}
                          </div>
                        </Col>
                        <Col xs="1">
                          {item.note && (
                            <span
                              class="material-icons cursor-pointer"
                              onClick={(e) => {
                                e.stopPropagation();
                                setNote(item.note);
                                seFoodName(item.name);
                                setShowNoteDialog(true);
                              }}
                              style={{
                                fontSize: 22,
                                color: primaryColor,
                                fontWeight: 400,
                              }}
                            >
                              insert_drive_file
                            </span>
                          )}
                        </Col>
                      </Row>
                    </Col>
                    <Col xs="3" className="text-center">
                      <span>{item.quantity}</span>
                    </Col>
                    <Col xs="3" className="text-end">
                      <span>
                        {getTotalPriceOfFoodItem(item.price, item.quantity)}
                      </span>
                    </Col>
                  </Row>
                ))
              : ""}

            {order.dataArray.length > 3 && (
              <div className="d-flex mb-2">
                <p
                  style={{
                    textDecoration: "underline",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  {strings.view_all}
                </p>
              </div>
            )}

            <hr className="my-0" />
          </CardBody>

          {/* Footer: Subtotal and Total */}
          <CardFooter className="orderItemCardFooter">
            <div className="bg-primary px-2 rounded">
              <Row
                className="fw-bold rounded py-1"
                style={{ color: "white", fontSize: 14 }}
              >
                <Col xs="6" md="6">
                  <Col>{strings.total}</Col>
                </Col>
                <Col xs="3" md="3" className="text-center">
                  {getTotalQty()}
                </Col>
                <Col xs="3" md="3" className="text-end">
                  {formateNumber(order.totalAmount)}
                </Col>
              </Row>
            </div>
          </CardFooter>
        </Card>
      </div>
      {showNoteDialog && (
        <FoodInstructionDialog
          setShowModal={setShowNoteDialog}
          showModal={showNoteDialog}
          note={note}
          itemName={foodName}
        />
      )}
    </>
  );
}

export default OrderItemsCard;
